import React from "react";

import { FaBriefcase,FaCamera, FaHamburger, FaCoffee,FaGlassMartini,FaBus } from "react-icons/fa";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { HiLocationMarker } from "react-icons/hi";
import { MdLocalDining ,MdDirectionsWalk, MdGroups,MdTimer} from "react-icons/md";



export  const  getIcon =(inclusionType, customIconColor = '#A9A9A9')=>{

    switch (inclusionType){
        case  "Equipment":
            return <FaBriefcase style={{marginLeft:'auto', fontSize:22, color : customIconColor}} />
        case "Pictures":
            return <FaCamera style={{marginLeft:'auto', fontSize:22, color : customIconColor}} />      
         case "Food":
            return <FaHamburger style={{marginLeft:'auto', fontSize:22, color : customIconColor}} />      
        case "Beverage":
            return <FaCoffee style={{marginLeft:'auto', fontSize:22, color : customIconColor}} />      
        case "Alcohol":
            return <FaGlassMartini style={{marginLeft:'auto', fontSize:22, color : customIconColor}} />      
        case "Transportation":
            return <FaBus style={{marginLeft:'auto', fontSize:22, color : customIconColor}} />      
        case "Other":
            return <BiDotsHorizontalRounded style={{marginLeft:'auto', fontSize:22, color : customIconColor}} />      
                 
        case "Location":
            return <HiLocationMarker style={{height:20,width:20}} />      
        case "MdLocalDining":
            return <MdLocalDining style={{height:20,width:20}} />      
        case "MdDirectionsWalk":
            return <MdDirectionsWalk style={{height:20,width:20}} />     
        case "MdGroups":
            return <MdGroups style={{height:20,width:20}} />                
        case "MdTimer":
            return <MdTimer style={{height:20,width:20}} />                
                
        default:
            return <p style={{marginLeft:'auto', fontSize:22, color: customIconColor}}>@</p> 

    }
    

}